import { render, staticRenderFns } from "./TabelaAgingComponent.vue?vue&type=template&id=8ca0496e"
import script from "./TabelaAgingComponent.vue?vue&type=script&lang=js"
export * from "./TabelaAgingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports